import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  LayoutDashboard, Ticket, PlusCircle, Settings, LogOut,
  Info, Calendar, ChevronRight, Lock, Users
} from 'lucide-react';
import './AppLayout.css';

export default function AppLayout() {
  const { user, logout, isStaff, isClient, isAdmin, isSupportLead } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/tickets', icon: Ticket, label: 'Tickets' },
    { to: '/tickets/new', icon: PlusCircle, label: 'Raise ticket' },
  ];

  // Admin/staff-only items
  if (isStaff) {
    if (isAdmin || isSupportLead) {
      navItems.push({ to: '/admin/metadata', icon: Settings, label: 'Configuration' });
      navItems.push({ to: '/admin/client-users', icon: Users, label: 'Client users' });
    }
  }

  // Info section for all users
  navItems.push(
    { to: '/info/calendar', icon: Calendar, label: 'Holiday calendar' },
    { to: '/info/manual', icon: Info, label: 'Usage manual' },
  );

  return (
    <div className="app-layout">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-brand">
          <div className="brand-logo">
            <img src="/axslogic_logo.png" alt="Axslogic" className="brand-icon-img" />
            <div className="brand-text">
              <span className="brand-name">Axslogic</span>
              <span className="brand-sub">Support Portal</span>
            </div>
          </div>
        </div>

        <nav className="sidebar-nav">
          {navItems.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon size={18} />
              <span>{label}</span>
              <ChevronRight size={14} className="nav-arrow" />
            </NavLink>
          ))}
          {isClient && (
              <NavLink
                  to="/change-password"
                  className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              >
                <Lock size={18} />
                <span>Change password</span>
                <ChevronRight size={14} className="nav-arrow" />
              </NavLink>
          )}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{user?.name?.[0] || 'U'}</div>
            <div className="user-details">
              <span className="user-name">{user?.name}</span>
              <span className="user-role">
                {user?.user_type === 'CLIENT' ? user?.client_name : user?.role}
              </span>
            </div>
          </div>
          <button className="logout-btn" onClick={handleLogout} title="Logout">
            <LogOut size={18} />
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
